export default __webpack_public_path__ + "static/media/img1.42d7382f.jpg";